import React from 'react';
import { Check, ShieldCheck, ArrowRight } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-sage-50" data-id="element-161">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-sage-100" data-id="element-163">
          <div className="flex flex-col md:flex-row" data-id="element-164">
            {/* Left Side: Value Stack */}
            <div className="p-8 md:p-12 md:w-3/5 bg-white" data-id="element-165">
              <h2 className="text-3xl font-serif font-bold text-charcoal mb-2" data-id="element-166">
                Protocolo Vientre Plano 21D
              </h2>
              <p className="text-sage-600 font-medium mb-6" data-id="element-167">
                Edición Digital Completa
              </p>

              <div className="space-y-4 mb-8" data-id="element-168">
                <div className="flex items-center gap-3" data-id="element-169">
                  <div className="w-6 h-6 rounded-full bg-sage-100 flex items-center justify-center" data-id="element-170">
                    <Check className="w-4 h-4 text-sage-600" data-id="element-171" />
                  </div>
                  <span className="text-charcoal-light" data-id="element-172">
                    Plan de 21 días paso a paso
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-173">
                  <div className="w-6 h-6 rounded-full bg-sage-100 flex items-center justify-center" data-id="element-174">
                    <Check className="w-4 h-4 text-sage-600" data-id="element-175" />
                  </div>
                  <span className="text-charcoal-light" data-id="element-176">Traker de hábitos</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-177">
                  <div className="w-6 h-6 rounded-full bg-sage-100 flex items-center justify-center" data-id="element-178">
                    <Check className="w-4 h-4 text-sage-600" data-id="element-179" />
                  </div>
                  <span className="text-charcoal-light" data-id="element-180">
                    Guía de alimentación anti-inflamatoria
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-181">
                  <div className="w-6 h-6 rounded-full bg-sage-100 flex items-center justify-center" data-id="element-182">
                    <Check className="w-4 h-4 text-sage-600" data-id="element-183" />
                  </div>
                  <span className="text-charcoal-light" data-id="element-184">
                    Acceso de por vida + Actualizaciones
                  </span>
                </div>
              </div>

              <div className="bg-beige-50 p-4 rounded-xl border border-beige-200 flex items-start gap-3" data-id="element-185">
                <ShieldCheck className="w-6 h-6 text-sage-600 flex-shrink-0" data-id="element-186" />
                <div data-id="element-187">
                  <p className="font-bold text-charcoal text-sm" data-id="element-188">
                    Garantía de 7 Días
                  </p>
                  <p className="text-xs text-charcoal-light" data-id="element-189"></p>
                </div>
              </div>
            </div>

            {/* Right Side: Pricing & CTA */}
            <div className="p-8 md:p-12 md:w-2/5 bg-sage-600 text-white flex flex-col justify-center items-center text-center relative overflow-hidden" data-id="element-190">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -mr-10 -mt-10" data-id="element-191"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-10 rounded-full -ml-10 -mb-10" data-id="element-192"></div>

              <p className="text-sage-200 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-193">
                Oferta Especial
              </p>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-194">
                <span className="text-sage-200 line-through text-xl" data-id="element-195">$37</span>
                <span className="text-5xl font-serif font-bold" data-id="element-196">$6.39</span>
              </div>
              <p className="text-sage-100 text-sm mb-8" data-id="element-197">
                Pago único • Acceso inmediato
              </p>

              <button onClick={() => window.location.href = 'https://www.viaesencial.com/cart/52778135028050:1'} className="w-full py-4 bg-white text-sage-700 font-bold rounded-full shadow-lg hover:bg-cream-50 hover:scale-105 transition-all flex items-center justify-center gap-2" data-id="element-198">
                Comenzar Ahora
                <ArrowRight className="w-5 h-5" data-id="element-199" />
              </button>

              <p className="mt-4 text-xs text-sage-200 opacity-80" data-id="element-200">
                Pago seguro con encriptación SSL
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}